import React, { useMemo, useReducer, createContext } from 'react';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

import globalReducer from './reducer';
import { ConfigType } from '../types';
import {
  AUTH_COOKIE,
  LOCAL_STORAGE,
} from '@invideoio/web-shared/utils/utils.constant';
import { AUTH_TAB } from '@invideoio/web-shared/components/Auth/constants';

const initialRootState = {
  authModal: {
    state: false,
    tab: 'signup',
  },
  teamInviteModal: {
    state: false,
  },

  teamSelectionModal: {
    state: false,
  },
  teamJoinedModal: {
    state: false,
  },

  typeFormPersonalModal: {
    state: false,
  },

  errorToast: {
    state: false,
    data: null,
  },
  redirectionLink: '',
  socialLinks: {
    twitterHandle: '',
    twitter: '',
    facebook: '',
    instagram: '',
    youtube: '',
    linkedin: '',
    pinterest: '',
    reviews: false,
  },
  planData: [],
  editorParams: {},
};

export const StateContext = createContext<any>(null);
export const DispatchContext = createContext<any>(null);
export const RedirectContext = createContext<any>(null);

type ContextType = {
  initialState?: {
    os: string;
    platform: string;
    browser: string;
    socialLinks: Record<string, any>;
    config: ConfigType;
  };
};

const GlobalContext = ({
  children,
  initialState,
}: React.PropsWithChildren<ContextType>) => {
  const [state, dispatch] = useReducer(globalReducer, {
    ...initialRootState,
    ...initialState,
  });

  const router = useRouter();

  const stateMemo = useMemo(() => state, [state]);
  const dispatchMemo = useMemo(() => dispatch, [dispatch]);

  const handleClick = (link: string | null = null, tab: string) => {
    const url = new URL(
      process.env.NEXT_PUBLIC_STUDIO_HOST || 'https://studio.invideo.io',
    );

    const params = router.query;

    if (params) {
      Object.keys(params).forEach(key => {
        if (typeof params[key] === 'string') {
          url.searchParams.append(key, params[key] as string);
        }
      });
    }

    if (localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)) {
      const paramObj = {
        token: localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN),
        token_expires: localStorage.getItem('authExpires'),
      };

      if (link) {
        let linkUrl = new URL(link, process.env.NEXT_PUBLIC_STUDIO_HOST);

        url.searchParams.append(
          'otherUrl',
          encodeURIComponent(linkUrl.pathname + linkUrl.search),
        );
      }
      url.searchParams.append(
        'token',
        window.btoa(JSON.stringify(paramObj)) || '',
      );

      url.pathname = '/redirect';

      localStorage.removeItem(LOCAL_STORAGE.AUTH_TOKEN);
      localStorage.removeItem('authExpires');

      Cookies.remove(AUTH_COOKIE.AUTH_TOKEN);

      window.open(url.toString(), '_self');
    } else {
      if (link) {
        const linkUrl = new URL(link, process.env.NEXT_PUBLIC_STUDIO_HOST);
        url.searchParams.append(
          'otherUrl',
          encodeURIComponent(linkUrl.pathname + linkUrl.search),
        );
      }
      if (tab === AUTH_TAB.LOGIN) {
        url.pathname = '/login';
      } else if (tab === AUTH_TAB.SIGN_UP) {
        url.pathname = '/signup';
      }

      window.open(url.toString(), '_self');
    }
  };

  return (
    <StateContext.Provider value={stateMemo}>
      <DispatchContext.Provider value={dispatchMemo}>
        <RedirectContext.Provider value={{ handleClick }}>
          {children}
        </RedirectContext.Provider>
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};

export default GlobalContext;
